import apiClient from './axios';

export interface FormTranslationDto {
    languageCode: string;
    title: string;
    description?: string;
    successMessage?: string;
    submitButtonText?: string;
}

export interface FormFieldTranslationDto {
    languageCode: string;
    label: string;
    placeholder?: string;
    helpText?: string;
}

export interface FormFieldDto {
    id?: string;
    name: string;
    type: 'text' | 'email' | 'number' | 'select' | 'checkbox' | 'textarea';
    isRequired: boolean;
    orderIndex: number;
    options?: string;
    label?: string; // For public view mapped translation
    placeholder?: string;
    helpText?: string;
    translations: FormFieldTranslationDto[];
}

export interface FormDto {
    id: string;
    slug: string;
    name: string;
    isActive: boolean;
    title?: string;
    description?: string;
    successMessage?: string;
    submitButtonText?: string;
    fields: FormFieldDto[];
    translations: FormTranslationDto[];
}

export interface FormSubmissionDto {
    id: string;
    formDefinitionId: string;
    formName: string;
    formData: string; // JSON string
    status: string;
    createdAt: string;
    ipAddress?: string;
}

export const formsApi = {
    // Admin
    getAdminForms: async (params: { pageNumber: number; pageSize: number }) => {
        const response = await apiClient.get('/admin/forms', { params });
        return response.data;
    },
    getAdminFormById: async (id: string) => {
        const response = await apiClient.get(`/admin/forms/${id}`);
        return response.data;
    },
    createForm: async (data: Partial<FormDto>) => {
        const response = await apiClient.post('/admin/forms', data);
        return response.data;
    },
    updateForm: async (id: string, data: Partial<FormDto>) => {
        const response = await apiClient.put(`/admin/forms/${id}`, data);
        return response.data;
    },
    deleteForm: async (id: string) => {
        const response = await apiClient.delete(`/admin/forms/${id}`);
        return response.data;
    },
    getSubmissions: async (params: { pageNumber: number; pageSize: number; formDefinitionId?: string }) => {
        const response = await apiClient.get('/admin/forms/submissions', { params });
        return response.data;
    },

    // Public
    getPublicForm: async (id: string) => {
        const response = await apiClient.get(`/public/forms/${id}`);
        return response.data;
    },
    submitForm: async (data: { formDefinitionId: string; data: any; recaptchaToken: string; relatedEntityId?: string; relatedEntityType?: string }) => {
        const response = await apiClient.post('/public/forms/submit', data);
        return response.data;
    }
};
